import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: "Pretendard, SeoulHangang, sans-serif",
  },
});

export default theme;